import { trackPromise } from 'react-promise-tracker';
import { fetchWithAuth } from './fetchWithAuth';

export async function getArticles(userToken) {
    return trackPromise(
        fetchWithAuth(
            'https://t41bx8uqf6.execute-api.us-east-2.amazonaws.com/prod/votacion/articulos',
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'authorizationToken': userToken
                }
            }
        )
    );
}
